// BUILDER IO ROUTES
const base = '/p'

export const builderIoRoutes = {
  selfPublishing: `${base}/self-publishing`,
}
